import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useState } from 'react';
import { useAppSelector, useScrollContext, useSessionContext } from "../../../../../shared/model";
var getRange = function getRange(text, word) {
  var index = text.toLowerCase().indexOf(word.toLowerCase());
  if (index !== -1) {
    var endIndex = index + word.length - 1;
    return [index, endIndex];
  }
  return [0, 0];
};
var setHighLight = function setHighLight(node, search) {
  var _CSS;
  var range = new Range();
  var _getRange = getRange(node.childNodes[0].textContent || '', search),
    _getRange2 = _slicedToArray(_getRange, 2),
    start = _getRange2[0],
    end = _getRange2[1];
  range.setStart(node.childNodes[0], start);
  range.setEnd(node.childNodes[0], end);
  var colorHighlight = new Highlight(range);

  // @ts-ignore
  (_CSS = CSS) === null || _CSS === void 0 || (_CSS = _CSS.highlights) === null || _CSS === void 0 || _CSS.set('message-text-highlight', colorHighlight);

  // @ts-ignore
  colorHighlight.add(range);
};
export var useSearchNavigation = function useSearchNavigation() {
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useAppSelector = useAppSelector(function (store) {
      return store.filters;
    }),
    search = _useAppSelector.search,
    isFiltersVisible = _useAppSelector.isFiltersVisible;
  var _useSessionContext = useSessionContext(),
    includedIds = _useSessionContext.includedIds,
    refs = _useSessionContext.refs;
  var _useScrollContext = useScrollContext(),
    scrollRef = _useScrollContext.scrollRef;
  var upDisabled = position >= includedIds.length;
  var downDisabled = position <= 1;
  var hidden = !search || !isFiltersVisible;
  useEffect(function () {
    if (!hidden && search) {
      var ref = refs[includedIds[position - 1]];
      if (ref !== null && ref !== void 0 && ref.current) {
        var _scrollRef$current;
        var text = ref.current.querySelector('[data-is-text]');
        if (text) {
          setHighLight(text, search);
        }
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.scrollTo({
          top: ref.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }
    }
  }, [position, search, includedIds]);
  useEffect(function () {
    return function () {
      var _CSS2;
      // @ts-ignore
      (_CSS2 = CSS) === null || _CSS2 === void 0 || (_CSS2 = _CSS2.highlights) === null || _CSS2 === void 0 || _CSS2.delete('message-text-highlight');
    };
  }, [hidden]);
  return {
    position: position,
    setPosition: setPosition,
    hidden: hidden,
    upDisabled: upDisabled,
    downDisabled: downDisabled,
    count: includedIds.length
  };
};